(function() {
  'use strict';
  angular
    .module('app.shared')
    .controller('CustomerListController', CustomerListController);

  CustomerListController.$inject = [
    '$state',
    '$stateParams',
    'APP_CONSTANTS',
    'toaster',
    'CustomerService',
    '$uibModal',
    '$scope'
  ];

  function CustomerListController(
    $state,
    $stateParams,
    APP_CONSTANTS,
    toaster,
    CustomerService,
    $uibModal,
    $scope
  ) {
    var vm = this;

    $scope.$parent.vm.setActiveTab();
    $scope.$parent.vm.generateBreadCrumbs($state.current.title);

    vm.register = register;
    vm.closeModal = closeModal;
    vm.loginAsCustomer = loginAsCustomer;
    vm.openCreateCustomerModal = openCreateCustomerModal;

    vm.pageNumber = 1;
    vm.pageSize = 10;
    vm.searchKey = '';
    vm.orderCol = 1;
    vm.sortBy = 'name';
    vm.orderBy = 'asc';
    vm.totalRecords = 0;
    vm.refreshTimeStamp = Date.now();
    vm.pageSizeOptions = APP_CONSTANTS.pageSizeOptions;
    vm.pageSizeOption = {
      key: "'" + vm.pageSize + "'",
      value: vm.pageSize
    };

    $.fn.dataTable.ext.order['customer-custom-sort'] = function(settings, col) {
      const orderBy = _.get(settings, 'aaSorting[0][1]');
      const sortBy = _.get(settings, ['aoColumns', col, 'sortBy']);

      if (!sortBy || orderBy == vm.orderBy && sortBy == vm.sortBy) return false;

      vm.orderBy = orderBy;
      vm.sortBy = sortBy;
      fetchUserList();
      return false;
    };
    vm.dtOptions = {
      paging: false,
      searching: false,
      info: false,
      order: [],
      columnDefs: [
        {
          orderable: false,
          targets: 'no-sort'
        },
        {
          orderDataType: 'customer-custom-sort',
          targets: '_all'
        }
      ]
    };

    function fetchUserList() {
      vm.fetchCustomerLoading = true;
      CustomerService.fetchCustomerList(
        vm.pageNumber,
        vm.pageSize,
        vm.searchKey,
        $stateParams.isLMSCustomer,
        vm.sortBy,
        vm.orderBy
      ).then(
        function(response) {
          vm.customerList = response.data.data.customers;

          vm.pageNumber = response.data.data.pageNumber
            ? response.data.data.pageNumber
            : 1;
          vm.pageSize = response.data.data.pageSize
            ? response.data.data.pageSize
            : 10;
          vm.totalRecords = response.data.data.totalRecords;
          vm.refreshTimeStamp = Date.now();
          vm.pageSizeOption = {
            key: "'" + vm.pageSize + "'",
            value: vm.pageSize
          };
          vm.fetchCustomerLoading = false;
        },
        function(error) {
          toaster.pop({
            type: 'error',
            body: error.data.message || error.statusText,
            toasterId: 'ckAdmin'
          });

          vm.fetchCustomerLoading = false;
        }
      );
    };

    fetchUserList();

    vm.getTableData = function(event) {
      var $targetElement = $(event.currentTarget);

      if (
        !$targetElement.hasClass('disabled') &&
        !$targetElement.hasClass('current')
      ) {
        vm.pageNumber = $targetElement.data('pageNum');
        fetchUserList();
      }
    };

    vm.pageSizeChanged = function() {
      vm.pageSize = vm.pageSizeOption;
      vm.searchKey = '';
      vm.pageNumber = 1;
      fetchUserList();
    };

    vm.searchByKey = function(event) {
      if (event.keyCode !== 13) return;

      vm.pageNumber = 1;
      fetchUserList();
    };

    function closeModal() {
      $scope.modalInstance.close();
    }

    function openCreateCustomerModal() {
      $scope.modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/ckadmin/customers/views/addCustomer.html',
        controller: 'AddCustomerController',
        controllerAs: 'regController',
        size: 'lg',
        scope: $scope
      });
    }

    function loginAsCustomer(customer) {
      vm.fetchCustomerLoading = true;

      CustomerService.loginAsCustomer(customer.id)
        .catch(error => {
          vm.fetchCustomerLoading = false;
          toaster.pop({
            type: 'error',
            body: error.data.message || error.statusText,
          });
        });
    }

    function register(valid) {
      var vm = this;

      if (!valid) {
        vm.formSubmit = true;

        return;
      }
      vm.registrationData.password = '';
      CustomerService.storeRegistrationInfo(vm.registrationData);
      vm.customerRegistrationLoader = true;
      CustomerService.register().then(
        function() {
          $scope.modalInstance.close();
          CustomerService.destroyRegistrationData();
          vm.customerRegistrationLoader = false;
          $state.go('login');
        },
        function(error) {
          vm.customerRegistrationLoader = false;
          toaster.pop({
            type: 'error',
            body: error.data.message || error.statusText,
            toasterId: 'ckAdmin'
          });
        }
      );
    }
  }
})();
